module.exports = __webpack_public_path__ + "static/media/poi_marker_multi.32b1199b.svg";